/**
 * Whether this visit to Your Plan is the first arrival after finishing, which shows the restrained
 * "Your plan is ready" moment. The finishing action passes `PLAN_READY_STATE` in router state; this
 * notes it (also when it arrives while Your Plan is already open, as after a legacy stamp), then
 * replaces the history entry without it, so refreshing, Back/Forward and later visits all show plain
 * "Your plan".
 */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const PLAN_READY_STATE = { planReady: true } as const;

function isPlanReadyState(state: unknown): boolean {
  return (state as { planReady?: unknown } | null)?.planReady === true;
}

export function usePlanReadyArrival(): boolean {
  const location = useLocation();
  const navigate = useNavigate();
  const [isFirstArrival, setIsFirstArrival] = useState(() => isPlanReadyState(location.state));

  useEffect(() => {
    if (isPlanReadyState(location.state)) {
      setIsFirstArrival(true);
      navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
    }
  }, [location.pathname, location.search, location.state, navigate]);

  return isFirstArrival;
}
